// assets/free-shipping-banner.js
import { CartAddEvent } from '@theme/events';

class FreeShippingBanner extends HTMLElement {
  connectedCallback() {
    // Threshold comes from data-threshold (in dollars)
    this.threshold = parseFloat(this.dataset.threshold);
    if (!isFinite(this.threshold) || this.threshold <= 0) {
      this.hidden = true;
      return;
    }
    this.thresholdCents = Math.round(this.threshold * 100);

    // Update on load/open
    this.#updateFromAjax();

    // Update when an item is added (theme's standard event)
    document.addEventListener(CartAddEvent?.eventName || 'cart:added', this.#updateFromAjax, { passive: true });

    // Update when the drawer content changes (qty/remove/etc.)
    const drawer = this.closest('cart-drawer-component') || document;
    const items = drawer.querySelector('cart-items-component');
    if (items) {
      this._mo = new MutationObserver(() => this.#updateFromAjax());
      this._mo.observe(items, { childList: true, subtree: true });
    }

    // As an extra safety net, react to clicks on +/- or remove buttons inside the drawer
    drawer.addEventListener('click', (e) => {
      if (e.target.closest('button[name="plus"], button[name="minus"], [data-index], .cart-remove-button')) {
        setTimeout(() => this.#updateFromAjax(), 120);
      }
    });
  }

  disconnectedCallback() {
    this._mo?.disconnect();
  }

  #setMessage(totalCents) {
    if (totalCents >= this.thresholdCents) {
      this.innerHTML = `<strong>Congratulations!</strong> You've earned Free Shipping!`;
      this.classList.add('is-earned');
      return;
    }
    const remaining = ((this.thresholdCents - totalCents) / 100).toFixed(2);
    this.innerHTML = `You are <span class="remaining">${remaining}</span> away from FREE SHIPPING!`;
    this.classList.remove('is-earned');
  }

  #updateFromAjax = async () => {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      const cart = await res.json();
      this.#setMessage(cart.total_price);
    } catch (e) {
      // Silently ignore; banner will show SSR content
    }
  };
}

if (!customElements.get('free-shipping-banner')) {
  customElements.define('free-shipping-banner', FreeShippingBanner);
}
